import { baseApi } from "./baseApi";

const ACCOUNT_LEDGER_BASE_URL = "account-ledgers";

export const accountLedgerApi = baseApi.injectEndpoints({
  tagTypes: ["AccountLedger"],

  endpoints: (build) => ({
    createAccountLedger: build.mutation({
      query: (body) => ({
        url: ACCOUNT_LEDGER_BASE_URL,
        method: "POST",
        body,
      }),
    }),

    listAccountLedger: build.query({
      query: (params) => ({
        url: ACCOUNT_LEDGER_BASE_URL,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result?.data?.map(({ _id }) => ({
                type: "AccountLedger",
                _id,
              })),
              { type: "AccountLedger", id: "LIST" },
            ]
          : [{ type: "AccountLedger", id: "LIST" }],
    }),

    getAccountLedgerDetail: build.query({
      query: (id) => `${ACCOUNT_LEDGER_BASE_URL}/${id}`,
      providesTags: (result, error, id) => [
        { type: "AccountLedger", id },
        { type: "AccountLedger", id: "LIST" },
      ],
    }),

    updateAccountLedger: build.mutation({
      query: (payload) => {
        const { _id, ...body } = payload;
        return {
          url: `${ACCOUNT_LEDGER_BASE_URL}/${_id}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: (result, error, { _id }) => [
        { type: "AccountLedger", _id },
        { type: "AccountLedger", id: "LIST" },
      ],
    }),
  }),
});

export const {
  useCreateAccountLedgerMutation,

  useLazyListAccountLedgerQuery,

  useAccountLedgerDetailQuery,

  useUpdateAccountLedgerMutation,

  useGetAccountLedgerDetailQuery,
} = accountLedgerApi;
